// Delivery ticks for the sender's OWN messages.
//
// They now sit on the light meta line UNDER the bubble rather than inside it,
// so the colours are tuned for a white/grey surface — the previous white-on-
// teal ticks would be invisible there. Only DoctorChatInterface and
// PatientChatInterface render this component, so the restyle is contained.

import React from 'react';
import { Check, CheckCheck, Clock } from 'lucide-react';

const LABELS = { sending: 'Sending', sent: 'Sent', delivered: 'Delivered', read: 'Seen' };

const MessageStatus = ({ status = 'sent' }) => {
    const label = LABELS[status] || LABELS.sent;
    return (
        <span
            className="inline-flex items-center ml-1"
            title={label}
            aria-label={label}
            data-testid={`message-status-${status}`}
        >
            {status === 'sending' && <Clock size={12} className="text-gray-400" strokeWidth={2.5} />}
            {status === 'sent' && <Check size={13} className="text-gray-400" strokeWidth={2.5} />}
            {status === 'delivered' && <CheckCheck size={13} className="text-gray-400" strokeWidth={2.5} />}
            {status === 'read' && <CheckCheck size={13} className="text-[#4ABDBD]" strokeWidth={2.5} />}
        </span>
    );
};

export default MessageStatus;
